import { responsiveFontSizes, createTheme, ThemeProvider } from '@mui/material';
export { ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import { e as _typeof } from '../_rollupPluginBabelHelpers-577f616b.js';
import { a as getDefaultExportFromCjs } from '../_commonjsHelpers-959d874c.js';
import { jsx } from 'react/jsx-runtime';

var src = {exports: {}};

(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isPlainObject = exports.clone = exports.recursive = exports.merge = exports.main = void 0;
  module.exports = exports = main;
  exports["default"] = main;

  function main() {
    var items = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }

    return merge.apply(void 0, items);
  }

  exports.main = main;
  main.clone = clone;
  main.isPlainObject = isPlainObject;
  main.recursive = recursive;

  function merge() {
    var items = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }

    return _merge(items[0] === true, false, items);
  }

  exports.merge = merge;

  function recursive() {
    var items = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }

    return _merge(items[0] === true, true, items);
  }

  exports.recursive = recursive;

  function clone(input) {
    if (Array.isArray(input)) {
      var output = [];

      for (var index = 0; index < input.length; ++index) {
        output.push(clone(input[index]));
      }

      return output;
    } else if (isPlainObject(input)) {
      var output = {};

      for (var index in input) {
        output[index] = clone(input[index]);
      }

      return output;
    } else {
      return input;
    }
  }

  exports.clone = clone;

  function isPlainObject(input) {
    return input && _typeof(input) === 'object' && !Array.isArray(input);
  }

  exports.isPlainObject = isPlainObject;

  function _recursiveMerge(base, extend) {
    if (!isPlainObject(base)) return extend;

    for (var key in extend) {
      if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
      base[key] = isPlainObject(base[key]) && isPlainObject(extend[key]) ? _recursiveMerge(base[key], extend[key]) : extend[key];
    }

    return base;
  }

  function _merge(isClone, isRecursive, items) {
    var result;
    if (isClone || !isPlainObject(result = items.shift())) result = {};

    for (var index = 0; index < items.length; ++index) {
      var item = items[index];
      if (!isPlainObject(item)) continue;

      for (var key in item) {
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        var value = isClone ? clone(item[key]) : item[key];
        result[key] = isRecursive ? _recursiveMerge(result[key], value) : value;
      }
    }

    return result;
  }
})(src, src.exports);

var merge = /*@__PURE__*/getDefaultExportFromCjs(src.exports);

var ggxThemeOptions = {
  palette: {
    primary: {
      main: '#0088BF'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  } // Adaptave font size example
  // typography: {
  //   button: {
  //     fontSize: '0.700rem',
  //     '@media (min-width:600px)': {
  //       fontSize: '0.750rem',
  //     },
  //     '@media (min-width:900px)': {
  //       fontSize: '0.800rem',
  //     },
  //     '@media (min-width:1200px)': {
  //       fontSize: '0.875rem',
  //     },
  //   },
  // },

};

var createCustomGGXTheme = function createCustomGGXTheme(options) {
  var newTheme = createTheme(merge.recursive(ggxThemeOptions, options));
  return responsiveFontSizes(newTheme);
};

var ggxTheme = responsiveFontSizes(createTheme(ggxThemeOptions));

var GGXThemeProvider = function GGXThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: ggxTheme,
    children: children
  });
};

var CustomThemeProvider = function CustomThemeProvider(_ref2) {
  var theme = _ref2.theme,
      children = _ref2.children;
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: theme,
    children: children
  });
};

GGXThemeProvider.propTypes = {
  children: PropTypes.node
};
CustomThemeProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object
};

export { CustomThemeProvider, GGXThemeProvider, createCustomGGXTheme, ggxTheme, ggxThemeOptions };
